@if (isDeprecated()) {
  <div class="doc-viewer-item-query-deprecated">
    <span class="doc-viewer-item-query-deprecated-title">
      {{ 'DOCS_DEPRECATED_TEXT' | translate }}
    </span>
    <span markdown [data]="deprecatedReason() || ''"> </span>
  </div>
}
